<template>
  <div style="display:inline-block" id="cal"></div>
</template>

<script>
import CalHeatMap from "cal-heatmap";
import { Time } from "@/lib/Time";

// TODO: Needs refactor. Shuold not get previous year.
export default {
  props: ["recordCache", "color", "config"],
  watch: {
    color: {
      handler(newColor) {
        this.calUpdateLegend(undefined, { min: "#EFEFEF", max: newColor });
      }
    },
    recordCache: {
      handler(newRecordCache) {
        this.updateData(newRecordCache);
      }
    }
  },
  data() {
    return {
      calUpdate: undefined,
      cal: undefined
    };
  },
  methods: {
    updateData(recordCache) {
      if (recordCache != undefined) {
        this.calUpdate(this.mapper(recordCache));
      }
    },
    mapper(recordCache) {
      let result = { ...recordCache.data };
      delete result["projectId"];
      delete result["recordCacheId"];
      delete result["userId"];
      return Object.entries(result).reduce((acc, curr) => {
        let info = curr[0].split("-");
        let key =
          Time.date
            .create({
              [Time.unit.year]: info[0],
              [Time.unit.month]: info[1],
              [Time.unit.day]: info[2]
            })
            .getTime() / 1000;
        let val = curr[1].value;
        // When duration is zero the entry is dropped
        if (val > 0) {
          acc[key] = val;
        }
        return acc;
      }, {});
    },
    startOfMonth(range) {
      return Time.date.subtract(
        Time.date.startOf(Time.unit.month),
        -(range + 1),
        Time.unit.month
      );
    }
  },
  computed: {
    computedConfig() {
      if (this.config.start == undefined) {
        return this.config;
      } else {
        return {
          ...this.config,
          start: this.startOfMonth(this.config.start)
        };
      }
    }
  },
  mounted() {
    let cal = new CalHeatMap();
    cal.init({
      itemSelector: this.$el,
      domain: "month",
      range: 1,
      cellSize: 10,
      dataType: "json",
      displayLegend: false,
      legend: [-1, 1800000, 3600000, 5400000],
      legendColors: { min: "#EFEFEF", max: this.color },
      subDomainTitleFormat: { empty: "{date}", filled: "{date}" },
      ...this.computedConfig
    });
    this.calUpdate = cal.update.bind(cal);
    this.calUpdateLegend = cal.setLegend.bind(cal);
    this.updateData(this.recordCache);
  }
};
</script>
